import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Customer } from './../../../../_shared/model/customer.model';
import { CustomerGuardian } from './../../../../_shared/model/customer/customer-guardian.model';
import { BaseState } from './../../../../_shared/state/base/base.state';
import { CustomerService } from './../../../pages/home/_services/customer.service';

@Component({
    selector: 'term-form-customer-details',
    templateUrl: './term-form-customer-details.component.html',
    styleUrls: ['./term-form-customer-details.component.scss'],
})
export class TermFormCustomerDetailsComponent implements OnInit {
    @Input()
    parent: FormGroup;

    @Input()
    set setCustomer(value) {
        this.customer = value;
        this.customerGuard = undefined;
        if (this.customer?.id) {
            this.getCustomerGuardian();
        }
    }
    private onDestroy$ = new Subject<void>();
    public customer: Customer;
    public customerGuard: CustomerGuardian;
    private contractorId: number = this.store.selectSnapshot(BaseState.activeContractorId);

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onFindSimilarCustomers: EventEmitter<any> = new EventEmitter();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onOpenCustomerEditForm: EventEmitter<any> = new EventEmitter();

    constructor(
        private rest: CustomerService,
        private store: Store,
    ) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    private getCustomerGuardian(): void {
        this.rest
            .getCustomerGuardians(this.contractorId, this.customer?.id)
            .pipe(
                takeUntil(this.onDestroy$),
                filter(cg => cg?.length > 0),
            )
            .subscribe(cg => {
                this.customerGuard = cg.shift();
            });
    }
}
